import React, { createRef, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
import queryString from 'query-string';
import { emptyOtpError, getOtp, submitOtp } from '../../actions/otpVerifcationAction';
import { OtpVerification } from '../../common';
import { Modal, OTPInputNew } from '../../helpers';
import { activityService } from '../../services';
import HomeAlertModal from '../home/homeAlertModal/HomeAlertModal';
import { liffGetProfile } from '../../services/promotion/auth.service';

const VerifyOtp = ({ location }) => {

  const dispatch = useDispatch();
  const history = useHistory();
  const { otpData, error: otpError } = useSelector(state => state.otpVerification);
  const customer = JSON.parse(sessionStorage.getItem('customer'));
  const otpRef = createRef();
  const urlParams = queryString.parse(location.search);

  const [invalid, setInvalid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [detailType, setDetailType] = useState('');
  const [user, setUser] = useState(null);
  const [modalContent, setModalContent] = useState('');
  const liff = window.liff;

  useEffect(() => {

    if (urlParams.type === 'member-abo') {
      setCountryCode(urlParams.phoneCntryCd); // get from query
      setPhoneNumber(urlParams.phoneLocalNum); // get from query
      if (!urlParams.phoneLocalNum) {
        handleToggleModal('NO_PHONE');
      }

    } else {
      setDetailType(location.state.detailType);
      setUser(location.state.user);
      setCountryCode(location.state.phoneList.phoneCntryCd);
      setPhoneNumber(location.state.phoneList.phoneLocalNum);
    }
  }, []);

  useEffect(() => {
    if (phoneNumber && countryCode) {
      handleFetchOtp();
    }
  }, [phoneNumber, countryCode]);

  useEffect(() => {
    if (otpError?.message === 'Invalid OTP' || otpError) {
      setLoading(false);
      setInvalid(true);
      dispatch(emptyOtpError());
      otpRef.current.clear();
      handleToggleModal('INVALID_OTP');
    }
  }, [otpError])

  const handleFetchOtp = async () => {
    try {
      setLoading(true);
      setInvalid(false);

      let custUid;
      if (customer?.uid) {
        custUid = customer?.uid;
      }
      else {
        const profile = await liffGetProfile();
        custUid = profile.userId;
      }

      dispatch(getOtp({
        context: `lbc-registration-${custUid}`,
        modeValue: `+${countryCode}${phoneNumber}`
      })).then(() => {
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });
    } catch (e) {
      setLoading(false);
    }
  }

  const handleOtpChange = () => {
    setLoading(false)
    setInvalid(false);
  }

  const handleSubmitOtp = (otp, props) => {
    const { isFilled } = props;
    if (isFilled) {
      if (!phoneNumber) {
        handleToggleModal('NO_PHONE');
        return;
      }
      setLoading(true);
      dispatch(submitOtp({
        otp,
        challengeId: otpData?.challengeId
      })).then(() => {
        if (urlParams.type === 'member-abo') {
          history.push('/member-upgrade/types');
        } else {
          switch (location?.state?.type) {
            case "otp":
              const { countryCode, type, ...formData } = location.state;
              history.push('/forgot', { ...formData, isOtpVerified: true });
              break;

            default:
              history.push('/success', { user, detailType });
              break;
          }
        }
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });
    }
  }

  const handleModalOk = () => setIsOpenModal(false);

  const handleToggleModal = (content) => {
    setModalContent(content);
    setIsOpenModal(isOpenModal => !isOpenModal);
  };

  const handleModalContent = () => {
    switch (modalContent) {
      case 'INVALID_OTP':
        return {
          title: 'รหัส OTP ไม่ถูกต้อง',
          description: 'กรุณาระบุข้อมูลใหม่อีกครั้ง',
          btnText: 'ระบุข้อมูลใหม่',
          onClose: handleModalOk,
          btnFn: handleModalOk
        };
      case 'NO_PHONE':
        return {
          title: 'ไม่พบเบอร์โทรศัพท์',
          description: 'โปรดติดต่อ Amway Contact center เพื่อเพิ่มหมายเลขโทรศัพท์ของท่าน หรือ เพิ่มข้อมูลบนเว็บไซต์ www.amway.co.th',
          btnText: 'โทร',
          onClose: () => liff.closeWindow(),
          btnFn: () => window.location = 'tel:027258000'
        };
      default:
        return;
    }
  };

  const content = handleModalContent();

  return (
    <div className="otp-verfication-container">
      {isOpenModal &&
        <HomeAlertModal
          title={content.title}
          description={content.description}
          btnFn={content.btnFn}
          isOpen={isOpenModal}
          onClose={content.onClose}
          btnText={content.btnText} />
      }
      <OtpVerification
        headerImage={urlParams.type === 'member-abo' ?
          '/images/renewalAndUpgrade/MemberUpgradeOTP.svg' :
          '/images/registration/AmwayLineBusinessConnectLogo.png'
        }
        imgContainerClass={urlParams.type === 'member-abo' ? ' otp-verfication_member-abo-img' : ''}
        headerText={`${urlParams.type === 'member-abo' ? '1. ' : ''}ยืนยันรหัส OTP`}
        otpText={'หมายเลข OTP จะถูกส่งไปยังหมายเลข'}
        phoneNumber={phoneNumber}
        footerText={urlParams.type === 'member-abo' ? 'กรณีเปลี่ยนเบอร์โทรศัพท์ สามารถแก้ไขได้ที่เว็ปไซต์\nAmway.co.th > บัญชีของฉัน' : 'ระบบจะยืนยันการลงทะเบียนของท่าน\nเมื่อทำการยืนยันตัวตนผ่านเบอร์โทรศัพท์เสร็จสมบูรณ์'}
        footerTextColor={urlParams.type === 'member-abo' ? '#2c2c2c' : ''}
      >
        <OTPInputNew
          loading={loading}
          ref={otpRef}
          invalid={invalid}
          count={6}
          onChange={invalid ? handleOtpChange : null}
          onLastInput={(val, props) => handleSubmitOtp(val, props)}
          resendFn={handleFetchOtp}
          resendBtn={true}
          delay={true}
          resendDelay={60}
          invalidMessage="รหัส OTP ไม่ถูกต้องกรุณาลองอีกครั้ง"
        />
      </OtpVerification>
      <LoadingOverlay active={loading} spinner text="Loading" styles={{ wrapper: { width: '100%', minHeight: '100%' } }} />
    </div >
  )
}

export default VerifyOtp
